module.exports = __webpack_public_path__ + "media/assets/images/flags/tm-f92bcad4a632c2b874e90ea4a8e00a95.svg";